// extracted by mini-css-extract-plugin
export default {"logoLink":"index_logoLink_e2FZg","subLogo":"index_subLogo_W-82k"};